import React, { useCallback } from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Skeleton from '@mui/lab/Skeleton';
import { useActionInputContext } from '../actionInputContext';
import PropertyTextEditor from '../../../../../../../PropertyTextEditor';
import THEME from '../../../../../../../../constants/theme';
import { useFlatFlowProperties } from '../../hooks/useFlatFlowProperties';
import { useStyles } from '../../styled';

const TextPropertyInput = () => {
  const {
    actionId,
    fieldValue,
    fieldObjectValue,
    fieldType,
    validationMessage,
    setInputField,
    placeholder,
    fieldId,
  } = useActionInputContext();

  const classes = useStyles();

  const selectTypes = useCallback(() => {
    if (fieldType) {
      return fieldId === 'message-text' && actionId?.includes('slack') ? [fieldType, 'FILE'] : [fieldType];
    }
    return null;
  }, [actionId, fieldId, fieldType]);

  const { getAvailableProperties: availableProperties, loading } = useFlatFlowProperties(selectTypes());

  const hasError = Boolean(validationMessage);
  const border = `1px solid ${hasError ? THEME.secondaryColors.nodeError : THEME.greyColors.grey8}`;

  return (
    <Box position="relative">
      <FormControl variant="standard" fullWidth error={hasError}>
        {loading ? (
          <Box p="12px 16px" borderRadius="8px" bgcolor="#f8f9f9" border={border}>
            <Skeleton height="32px" />
          </Box>
        ) : (
          <PropertyTextEditor
            showToolbar={false}
            initialEditorText={fieldValue || placeholder}
            border={border}
            handleSavePlainText={setInputField}
            properties={availableProperties}
            minHeight={fieldType === 'LONG_STRING' ? '100px' : 'none'}
            type={fieldType}
            initialOpsObject={fieldObjectValue}
          />
        )}

        {hasError && <FormHelperText classes={{ root: classes.root }}>{validationMessage}</FormHelperText>}
      </FormControl>
    </Box>
  );
};

export default TextPropertyInput;
